import React, { useState } from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, Button, Typography, CircularProgress } from "@mui/material";

export default function BrandRatingGenerationForm({
  rubrics,
  isLoadingRubrics,
  onGenerateRating,
  isGenerating
}) {
  const [selectedRubricId, setSelectedRubricId] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedRubricId) { return; }

    await onGenerateRating(parseInt(selectedRubricId, 10));
    setSelectedRubricId(""); // Reset selection after successful generation
  };

  if (isLoadingRubrics) {
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <CircularProgress size={16} />
        <Typography variant="body2">Loading rubrics...</Typography>
      </Box>
    );
  }

  if (!rubrics || rubrics.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No rating rubrics available.
      </Typography>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Box display="flex" gap={2} alignItems="center">
        <FormControl size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Select Rubric</InputLabel>
          <Select
            value={selectedRubricId}
            onChange={(e) => setSelectedRubricId(e.target.value)}
            label="Select Rubric"
            disabled={isGenerating}
          >
            {rubrics.map((rubric) => (
              <MenuItem key={rubric.id} value={rubric.id}>
                {rubric.category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button
          type="submit"
          variant="contained"
          disabled={!selectedRubricId || isGenerating}
        >
          {isGenerating
            ? (
              <>
                <CircularProgress size={16} sx={{ mr: 1 }} />
              Generating...
              </>
            )
            : (
              "Generate Brand Rating"
            )}
        </Button>
      </Box>
    </Box>
  );
}
